import React from "react";
import { ShieldCheck, Info, ArrowRight, ArrowUpRight, Star, Wrench, Link2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const PACKAGE_ICONS = [Star, Wrench, Link2];

export default function ReputationService() {
  const { t } = useLang();
  const r = t.reputation;
  return (
    <section
      id="reputation"
      className="section-y bg-brand-cloud"
      data-testid="reputation-section"
    >
      <div className="container-x">
        <div className="card-soft p-8 md:p-14 border-brand-mist/80">
          <div className="grid lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-7">
              <span className="overline inline-flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-brand-champagne" />
                {r.overline}
              </span>
              <h2 className="mt-5 text-3xl md:text-4xl lg:text-[44px] leading-tight font-semibold tracking-tight text-brand-ink text-balance">
                {r.title}
              </h2>
              <p className="mt-6 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
                {r.lead}
              </p>
              <p className="mt-4 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
                {r.body}
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href="/#contact"
                  className="btn-primary"
                  data-testid="reputation-cta"
                  onClick={() => {
                    window.sessionStorage.setItem("in7s_inquiry_type", "reputation");
                    window.dispatchEvent(
                      new CustomEvent("in7s:set-inquiry-type", { detail: "reputation" })
                    );
                  }}
                >
                  {r.cta}
                  <ArrowRight className="h-4 w-4" />
                </a>
                <a
                  href={r.externalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost"
                  data-testid="reputation-external-link"
                >
                  {r.external}
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl border border-brand-mist bg-white p-6 md:p-7">
                <div className="flex items-center justify-between">
                  <div className="font-heading text-lg font-medium text-brand-ink">
                    {r.packageTitle}
                  </div>
                  <span className="chip text-[10px]">NFC · Reputation</span>
                </div>
                <ul className="mt-5 space-y-4">
                  {r.packageItems.map((it, i) => {
                    const Icon = PACKAGE_ICONS[i];
                    return (
                      <li
                        key={i}
                        className="flex items-start gap-3"
                        data-testid={`reputation-package-${i}`}
                      >
                        <span className="mt-0.5 grid place-items-center h-8 w-8 rounded-full bg-brand-ink text-white shrink-0">
                          <Icon className="h-4 w-4" />
                        </span>
                        <div>
                          <div className="text-sm font-medium text-brand-ink">{it.k}</div>
                          <p className="mt-0.5 text-sm text-brand-graphite leading-relaxed">
                            {it.v}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                <div className="mt-6 rounded-xl bg-brand-cloud p-4 flex items-start gap-3">
                  <Info className="h-4 w-4 text-brand-stone shrink-0 mt-0.5" />
                  <p className="text-xs text-brand-graphite leading-relaxed">
                    {r.note}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
